import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import BreadcrumbsSection from "../../breadcrumbs/BreadcrumbsSection";
import DataTableWithOutSearch from "../../datatables/DataTableWithOutSearch";
import BranchModal from "./BranchModal";
import BranchModalEdit from "./BranchModalEdit";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { getAuthorizedBranchIds } from "../../../utils/authHelper";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import "./_branches.scss";
import SingleLocation from "./SingleLocation";
import { PageCardShimmer } from "../../preloader/PageCardShimmer";
import { canView } from "../../../../utils/modulePermissions";
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../../utils/moduleGuard";

// /settings/branches → "branches" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: "Settings" is the shared sidebar group, and
// can() grants an action when ANY matched row allows it, so matching the group name
// would let a sibling Settings module's grant leak in.
const BRANCHES_MODULE = ["branches"];
// Settings/branches has TWO permission rows with module_key "branches", split by
// sub_module_name: "branches" (this page) and "classes" (Branch Classes). Scope every
// check to the "branches" sub-module so the classes grant can't leak in here.
const BRANCHES_SUB = "branches";

const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
  headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap" },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  content: { padding: "20px 24px" },
};

const ADD_BRANCH = gql`
  mutation($branches: BranchesInput) {
    createBranch(branches: $branches)
  }
`;
const GET_GLOBALS = gql`
 query($institution_id: Int!) {
          globals(institution_id: $institution_id) {
        
            regions {
              id
              region
            }
            cities {
              id
              city_name
              region_id
            }
       
          }
        }
`;

const DELETE_BRANCH = gql`
  mutation($branch_id: ID) {
    removeBranch(branch_id: $branch_id)
  }
`;

const FETCH_BRANCHES = gql`
  query($institution_id: Int!) {
    getBranchesList(institution_id: $institution_id) {
      id
      branch_name
      contact_no
      complete_address
      region_id
      city_id
      organisation_structure_id
      hod
      hod_mobile
      principal
      principal_mobile
      vice_principal
      vice_principal_mobile
    }
  }
`;

const EDIT_BRANCH = gql`
  mutation($params: UpdateBranchInput) {
    modifyBranch(params: $params)
  }
`;
class BranchesSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow1: false,
      status: 1,
      currentStep: 1,
      branchid: "",
      branch: "",

      mobile: "",
      address: "",
      region: "",
      city_id: 0,
      organisation_structure_id: 0,
      hod: "",
      hod_mobile: "",
      principal: "",
      principal_mobile: "",
      vice_principal: "",
      vice_principal_mobile: "",
      submitError: "",
      formErrors: {
        branch: "",
        principal: "",
        mobile: "",
        hod_mobile: "",
        principal_mobile: "",
        vice_principal_mobile: "",
        region: "",
        city_id: ""
      },
      hod_mobileValid: false,
      principal_mobileValid: false,
      vice_principal_mobileValid: false,
      branchValid: false,
      principalValid: false,
      mobileValid: false,
      regionValid: false,
      cityValid: false,
      formValid: false,
      isEditSaving: false,
      isAddSaving: false,
      BranchesSection: {
        Title: "Branches",
        btnName: "Add New Branch"
      },
      tableHeaderData: {
        Title: "Branches"
      },
      modalShow: false,
      accessDeniedShow: false
    };

    this.guard = attachModuleGuard(this, BRANCHES_MODULE, BRANCHES_SUB);
  }

  // "Add New Branch" — the button stays visible and clickable; the grant is checked
  // here, before the create modal opens, so a role without is_edit gets Access Denied
  // instead of a form it could never submit.
  parentStateSet = () => {
    if (!this.guard.requireEdit()) return;

    console.log("sreee");
    this.setState({
      modalShow1: false,
      status: 1,
      currentStep: 1,
      branchid: "",
      branch: "",
      mobile: "",
      address: "",
      region: "",
      city_id: 0,
      organisation_structure_id: 0,
      hod: "",
      hod_mobile: "",
      principal: "",
      principal_mobile: "",
      vice_principal: "",
      vice_principal_mobile: "",
      submitError: "",
      formErrors: {
        branch: "",
        principal: "",
        mobile: "",
        hod_mobile: "",
        principal_mobile: "",
        vice_principal_mobile: "",
        region: "",
        city_id: ""
      },
      hod_mobileValid: false,
      principal_mobileValid: false,
      vice_principal_mobileValid: false,
      branchValid: false,
      principalValid: false,
      mobileValid: false,
      regionValid: false,
      cityValid: false,
      formValid: false,
      isEditSaving: false,
      isAddSaving: false,
      BranchesSection: {
        Title: "Branches",
        btnName: "Add New Branch"
      },
      tableHeaderData: {
        Title: "Branches"
      },
      modalShow: true
    });
  };
  InserthandleFormSubmit = e => {
    e.preventDefault();

    // Re-checked at submit, not only when the modal opened: the modal could already
    // be open when a grant changes, and this is the last gate before createBranch.
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow: false });
      return;
    }

    console.log("Form submitted");
    console.log("Cookies2", Cookies.get("username"));
    console.log("institutionid2", Cookies.get("institutionid"));

    if (this.state.formValid) {
      let addbranchobj = "";
      addbranchobj = {
        branch_name: this.state.branch,
        contact_no: this.state.mobile,
        complete_address: this.state.address,
        region_id: parseInt(this.state.region),
        city_id: parseInt(this.state.city_id),
        organisation_structure_id: parseInt(
          this.state.organisation_structure_id
        ),
        hod: this.state.hod,
        hod_mobile: this.state.hod_mobile,
        principal: this.state.principal,
        principal_mobile: this.state.principal_mobile,
        vice_principal: this.state.vice_principal,
        vice_principal_mobile: this.state.vice_principal_mobile,
        institution_id: parseInt(Cookies.get("institutionid")),
        username: Cookies.get("username")
      };
      this.setState({ isAddSaving: true });
      this.addbranch(addbranchobj).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          isAddSaving: false,
          submitError: error.graphQLErrors.map(x => x.message)
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };
  addbranch = async branches => {
    await this.props.addbranch({
      variables: {
        branches
      },
      update: (store, { data }) => {
        let data1 = store.readQuery({
          query: FETCH_BRANCHES,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("data1", data1);
        const newBranch = {
          id: data.createBranch,
          branch_name: this.state.branch,
          contact_no: this.state.mobile,
          complete_address: this.state.address,
          region_id: this.state.region,
          city_id: parseInt(this.state.city_id),
          organisation_structure_id: parseInt(
            this.state.organisation_structure_id
          ),
          hod: this.state.hod,
          hod_mobile: this.state.hod_mobile,
          principal: this.state.principal,
          principal_mobile: this.state.principal_mobile,
          vice_principal: this.state.vice_principal,
          vice_principal_mobile: this.state.vice_principal_mobile,
          __typename: "BranchInfo"
        };
        data1.getBranchesList.push(newBranch);

        try {
          store.writeQuery({
            query: FETCH_BRANCHES,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            },
            data: data1
          });
        } catch (e) {
          console.log("Exception", e);
        }
        if (data.createBranch) {
          this.props.globals.refetch();
          this.setState({
            isAddSaving: false,
            currentStep: 5,
            branch: "",

            mobile: "",
            address: "",
            region: "",
            city_id: 0,
            organisation_structure_id: 0,
            hod: "",
            hod_mobile: "",
            principal: "",
            principal_mobile: "",
            vice_principal: "",
            vice_principal_mobile: "",
            submitError: "",
            formErrors: {
              branch: "",
              principal: "",
              mobile: ""
            },
            branchValid: false,
            principalValid: false,
            mobileValid: false,
            formValid: false
          });

          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      }
    });
  };
  SetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ currentStep: 1, modalShow: false });
    //this.props.onHide()
  };

  // Editmodal functions
  handleFormSubmit = e => {
    e.preventDefault();

    // Last gate before updateBranch. Same reasoning as InserthandleFormSubmit.
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow1: false });
      return;
    }

    console.log("Form submitted");
    console.log("Cookies2", Cookies.get("username"));
    console.log("institutionid2", Cookies.get("institutionid"));

    if (this.state.formValid) {
      let editbranchobj = "";
      editbranchobj = {
        id: this.state.branchid,
        branch_name: this.state.branch,
        contact_no: this.state.mobile,
        complete_address: this.state.address,
        region_id: parseInt(this.state.region),
        city_id: parseInt(this.state.city_id),
        organisation_structure_id: parseInt(
          this.state.organisation_structure_id
        ),
        hod: this.state.hod,
        hod_mobile: this.state.hod_mobile,
        principal: this.state.principal,
        principal_mobile: this.state.principal_mobile,
        vice_principal: this.state.vice_principal,
        vice_principal_mobile: this.state.vice_principal_mobile,
        username: Cookies.get("username")
      };
      this.setState({ isEditSaving: true });
      this.editbranch(editbranchobj).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          isEditSaving: false,
          submitError: error.graphQLErrors.map(x => x.message)
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };
  editbranch = async params => {
    await this.props.editbranch({
      variables: {
        params
      },
      update: (store, { data }) => {
        let data1 = store.readQuery({
          query: FETCH_BRANCHES,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("data1", data1);
        console.log("this.state", this.state);

        let found = data1.getBranchesList.find(a => a.id === this.state.branchid);
        let idindex = data1.getBranchesList.indexOf(found);
        const newBranch = {
          id: this.state.branchid,
          branch_name: this.state.branch,

          contact_no: this.state.mobile,
          complete_address: this.state.address,
          region_id: this.state.region,
          city_id: parseInt(this.state.city_id),
          organisation_structure_id: parseInt(
            this.state.organisation_structure_id
          ),
          hod: this.state.hod,
          hod_mobile: this.state.hod_mobile,
          principal: this.state.principal,
          principal_mobile: this.state.principal_mobile,
          vice_principal: this.state.vice_principal,
          vice_principal_mobile: this.state.vice_principal_mobile,
          __typename: "BranchInfo"
        };
        data1.getBranchesList.splice(idindex, 1, newBranch);
        try {
          store.writeQuery({
            query: FETCH_BRANCHES,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            },
            data: data1
          });
        } catch (e) {
          console.log("Exception", e);
        }
        if (data.modifyBranch) {
          this.props.globals.refetch();
          this.setState({
            isEditSaving: false,
            currentStep: 5,
            branchid: "",
            branch: "",
            mobile: "",
            address: "",
            region: "",
            city_id: 0,
            organisation_structure_id: 0,
            hod: "",
            hod_mobile: "",
            principal: "",
            principal_mobile: "",
            vice_principal: "",
            vice_principal_mobile: "",
            submitError: "",
            formErrors: {
              branch: "",
              principal: "",
              mobile: ""
            },
            branchValid: false,
            principalValid: false,
            mobileValid: false,
            formValid: false
          });

          setTimeout(() => {
            this.SetpageLoad1();
          }, 1500);
        }
      }
    });
  };
  SetpageLoad1 = () => {
    console.log("setTimeout");
    this.setState({ currentStep: 1, modalShow1: false });
  };
  handleInputChange = e => {
    const name = e.target.name;
    let value = e.target.value;
    const mobileFields = ["mobile", "hod_mobile", "principal_mobile", "vice_principal_mobile"];
    if (mobileFields.includes(name)) {
      value = value.replace(/[^0-9]/g, "");
    }
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let branchValid = this.state.branchValid;
    let principalValid = this.state.principalValid;
    let mobileValid = this.state.mobileValid;
    let regionValid = this.state.regionValid;
    let cityValid = this.state.cityValid;

    let hod_mobileValid = this.state.hod_mobileValid;
    let principal_mobileValid = this.state.principal_mobileValid;
    let vice_principal_mobileValid = this.state.vice_principal_mobileValid;

    switch (fieldName) {
      case "branch":
        if (value.length == "") {
          branchValid = false;
          fieldValidationErrors.branch = "Branch Cannot Be Empty";
        } else {
          branchValid = true;
          fieldValidationErrors.branch = "";
        }

        break;

      case "principal":
        if (value.length == "") {
          principalValid = false;
          fieldValidationErrors.principal = "principal Cannot Be Empty";
        } else {
          principalValid = true;
          fieldValidationErrors.principal = "";
        }

        break;

      case "mobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");

        if (value.length == "") {
          mobileValid = false;
          fieldValidationErrors.mobile = "Mobile No. Cannot Be Empty";
        } else if (!pattern.test(value)) {
          mobileValid = false;
          fieldValidationErrors.mobile = "Invalid mobile";
        } else {
          mobileValid = true;
          fieldValidationErrors.mobile = "";
        }

        break;

      case "hod_mobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");

        if (value.length == "") {
          hod_mobileValid = false;
          fieldValidationErrors.hod_mobile = "Mobile No. Cannot Be Empty";
        } else if (!pattern.test(value)) {
          hod_mobileValid = false;
          fieldValidationErrors.hod_mobile = "Invalid mobile";
        } else {
          hod_mobileValid = true;
          fieldValidationErrors.hod_mobile = "";
        }

        break;

      case "principal_mobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");

        if (value.length == "") {
          principal_mobileValid = false;
          fieldValidationErrors.principal_mobile = "Mobile No. Cannot Be Empty";
        } else if (!pattern.test(value)) {
          principal_mobileValid = false;
          fieldValidationErrors.principal_mobile = "Invalid mobile";
        } else {
          principal_mobileValid = true;
          fieldValidationErrors.principal_mobile = "";
        }

        break;

      case "vice_principal_mobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");

        if (value.length == "") {
          vice_principal_mobileValid = false;
          fieldValidationErrors.vice_principal_mobile = "Mobile No. Cannot Be Empty";
        } else if (!pattern.test(value)) {
          vice_principal_mobileValid = false;
          fieldValidationErrors.vice_principal_mobile = "Invalid mobile";
        } else {
          vice_principal_mobileValid = true;
          fieldValidationErrors.vice_principal_mobile = "";
        }

        break;

      case "region":
        if (!value || parseInt(value) <= 0 || isNaN(parseInt(value))) {
          regionValid = false;
          fieldValidationErrors.region = "State Cannot Be Empty";
        } else {
          regionValid = true;
          fieldValidationErrors.region = "";
        }

        break;

      case "city_id":
        if (!value || parseInt(value) <= 0 || isNaN(parseInt(value))) {
          cityValid = false;
          fieldValidationErrors.city_id = "City Cannot Be Empty";
        } else {
          cityValid = true;
          fieldValidationErrors.city_id = "";
        }

        break;

      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        branchValid: branchValid,
        principalValid: principalValid,
        mobileValid: mobileValid,
        regionValid: regionValid,
        cityValid: cityValid,

        hod_mobileValid: hod_mobileValid,
        principal_mobileValid: principal_mobileValid,
        vice_principal_mobileValid: vice_principal_mobileValid
      },
      this.validateForm
    );
  }
  validateForm() {
    this.setState({
      formValid:
        this.state.principalValid &&
        this.state.branchValid &&
        this.state.mobileValid &&
        this.state.regionValid &&
        this.state.cityValid
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" }, () => { });
    }
  }

  commaSeparated = vals => {
    let newBranchArray = [];
    const regions = (this.props.globals.globals && this.props.globals.globals.regions) || [];
    const cities = (this.props.globals.globals && this.props.globals.globals.cities) || [];
    for (let i = 0; i < vals.length; i++) {
      const edata = vals[i];

      const regionMatch = regions.find(r => parseInt(r.id) === parseInt(edata.region_id));
      const cityMatch = cities.find(c => parseInt(c.id) === parseInt(edata.city_id));

      const newBranch = {
        id: edata.id,
        branch_name: edata.branch_name,
        complete_address: edata.complete_address,
        contact_no: edata.contact_no,

        region_id: edata.region_id,
        state_name: regionMatch ? regionMatch.region : "",
        city_id: parseInt(edata.city_id),
        city_name: cityMatch ? cityMatch.city_name : "",
        organisation_structure_id: parseInt(edata.organisation_structure_id),
        hod: edata.hod,
        hod_mobile: edata.hod_mobile,
        principal: edata.principal,
        principal_mobile: edata.principal_mobile,
        vice_principal: edata.vice_principal,
        vice_principal_mobile: edata.vice_principal_mobile,
      };
      newBranchArray.push(newBranch);
    }
    return newBranchArray;
  };
  // Row "edit" icon — checked before the edit modal opens, so a role without is_edit
  // never sees a form it isn't allowed to save.
  handleEditFunction = (e, cell, row, rowIndex, formatExtraData) => {
    if (!this.guard.requireEdit()) return;

    console.log("columnid", rowIndex);

    this.setState({
      modalShow1: true,
      branchid: rowIndex.id,
      branch: rowIndex.branch_name,

      mobile: rowIndex.contact_no,
      address: rowIndex.complete_address,
      region: rowIndex.region_id,
      city_id: parseInt(rowIndex.city_id),
      organisation_structure_id: parseInt(rowIndex.organisation_structure_id),
      hod: rowIndex.hod,
      hod_mobile: rowIndex.hod_mobile,
      principal: rowIndex.principal,
      principal_mobile: rowIndex.principal_mobile,
      vice_principal: rowIndex.vice_principal,
      vice_principal_mobile: rowIndex.vice_principal_mobile,
      status: 1,
      currentStep: 1,
      submitError: "",
      formErrors: {
        branch: "",
        principal: "",
        mobile: "",
        hod_mobile: "",
        principal_mobile: "",
        vice_principal_mobile: "",
        region: "",
        city_id: ""

      },
      hod_mobileValid: false,
      principal_mobileValid: false,
      vice_principal_mobileValid: false,
      branchValid: true,
      principalValid: true,
      mobileValid: true,
      regionValid: !!(rowIndex.region_id && parseInt(rowIndex.region_id) > 0),
      cityValid: !!(rowIndex.city_id && parseInt(rowIndex.city_id) > 0),
      formValid: true,

      modalShow: false
    }, this.validateForm);
  };

  handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
    // Checked BEFORE the confirm prompt: a role without is_delete should be told they
    // lack access, not asked to confirm a delete that was never going to happen.
    if (!this.guard.requireDelete()) return;

    if (!window.confirm(`Are you sure you want to delete branch "${rowIndex.branch_name}"?`)) {
      return;
    }
    await this.props.handleDelete({
      variables: {
        branch_id: rowIndex.id
      },
      update: (store, { data }) => {
        console.log("data", data);
        const data1 = store.readQuery({
          query: FETCH_BRANCHES,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });
        console.log("data1s", data1.getBranchesList);
        console.log("rowIndex.id", rowIndex.id);
        data1.getBranchesList = data1.getBranchesList.filter(x => x.id != rowIndex.id);
        console.log("data2s", data1.getBranchesList);
        try {
          store.writeQuery({
            query: FETCH_BRANCHES,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            },
            data: data1
          });
        } catch (e) {
          console.log("Exception", e);
        }

        const data4 = store.readQuery({
          query: FETCH_BRANCHES,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });
        data1.getBranchesList = data4;
        console.log("data4s", data4);
        if (data.removeBranch) {
          this.props.globals.refetch();
          this.setState({
            status: 2
          });
          setTimeout(() => {
            this.DeleteSetpageLoad();
          }, 1000);
        }
      }
    });
  };
  DeleteSetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ status: 1 });
  };

  actionsFormatter2(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="delete" className="text-danger">
          <i className="far fa-trash-alt" />
        </Button>
      </div>
    );
  }
  actionsFormatter1() {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="edit" className="text-theme">
          <i className="far fa-edit" />
        </Button>
      </div>
    );
  }

  actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="view" className="text-theme">
          <i className="far fa-eye" />
        </Button>
      </div>
    );
  }
  articlecolumns = [
    {
      dataField: "sno",
      text: "#",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerAlign: "center",
      align: "center",
      headerAttrs: { width: 50 }
    },
    {
      dataField: "branch_name",
      text: "Branch Name",
      headerAttrs: { width: 150 },
      sort: true,
      attrs: { className: "branch_name_row" }
    },
    // {
    //   dataField: "sections",
    //   text: "Sections",
    //   sort: true
    // },
    {
      dataField: "state_name",
      text: "State",
      sort: true
    },
    {
      dataField: "city_name",
      text: "City",
      sort: true
    },
    {
      dataField: "complete_address",
      text: "Address",
      sort: true,
      attrs: { className: "complexityRow" }
    },
    {
      dataField: "principal",
      text: "Principal",
      sort: true
    },
    {
      dataField: "contact_no",
      text: "Contact No.",
      sort: true,
      attrs: { className: "contact_no_row" }
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: this.actionsFormatter1,
      attrs: { className: "EditRow" },
      headerAlign: "center",
      events: {
        onClick: this.handleEditFunction
      }
    },
    {
      dataField: "dactions",
      text: "",
      formatter: this.actionsFormatter2,
      attrs: { className: "DeleteRow" },
      headerAlign: "center",
      events: {
        onClick: this.handleDelete
      }
    }
  ];
  render() {
    // is_view === 0 → the branch data is never rendered. The queries are skipped too
    // (see the graphql HOCs below), so nothing is fetched either. The page shell
    // (navbar / sidebar / footer) comes from Branches.jsx, so the user can still
    // navigate to modules they DO have.
    if (!this.guard.canView()) {
      return (
        <div style={FIN.wrapper} className="branches_section">
          <AccessDeniedCard />
        </div>
      );
    }

    console.log("CurrentState", this.state);

    const defaultSorted = [
      {
        dataField: "branch_name",
        order: "desc"
      }
    ];
    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getBranches = this.props.getBranches;
    const loading2 = getBranches.loading;
    const error2 = getBranches.error;

    if (loading1 || loading2) return <PageCardShimmer filters={4} />;
    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    // Show only the branches the user is authorized for. The branch_id cookie is a
    // comma-separated list (e.g. "10,12,15"), so match against every id. Both the table
    // and the stat cards below read from this scoped list.
    const authorizedIds = getAuthorizedBranchIds();
    const rawBranchList = this.props.getBranches.getBranchesList || [];
    const scopedBranchList = authorizedIds.length
      ? rawBranchList.filter((b) => authorizedIds.includes(String(b.id)))
      : rawBranchList;

    const branchRows = this.commaSeparated(scopedBranchList);

    // Stat-card data derived from the scoped branch list so the cards stay in sync with
    // the table. Region names are resolved from the globals regions master list.
    const branchList = scopedBranchList;
    const regionsMaster = (globals.globals && globals.globals.regions) || [];
    const regionNameById = {};
    regionsMaster.forEach(r => { regionNameById[r.id] = r.region; });
    const regionCounts = {};
    branchList.forEach(b => {
      const region = regionNameById[b.region_id] || "Unknown";
      regionCounts[region] = (regionCounts[region] || 0) + 1;
    });
    const branchStatData = {
      total_count: branchList.length,
      branch_data: Object.keys(regionCounts).map(region => ({
        region,
        count: regionCounts[region]
      }))
    };

    return (
      <div style={FIN.wrapper} className="branches_section">
        <Container fluid className="px-0">
          <div style={FIN.card}>
            <div style={FIN.cardHeader}>
              <div style={FIN.iconWrapper}><i className="fal fa-code-branch" /></div>
              <div style={FIN.titleText}>
                <h5 style={FIN.title}>Branches</h5>
                <span style={FIN.subtitle}>Manage institute branches</span>
              </div>
              <div style={FIN.headerActions}>
                <span style={FIN.countChip}>{branchRows.length} Branches</span>
                <button style={FIN.btnPrimary} onClick={this.parentStateSet}>
                  <i className="fas fa-plus" /> Add New Branch
                </button>
              </div>
            </div>
            <div style={FIN.content}>
              <div className="location_cards mb-3">
                <Row>
                  <SingleLocation
                    insid={parseInt(Cookies.get("institutionid"))}
                    branchData={branchStatData}
                  />
                </Row>
              </div>
              {this.state.status == 2 ? <p style={{ color: "#059669", fontWeight: 600 }}>Branch deleted successfully</p> : null}
              <DataTableWithOutSearch
                parentData={branchRows}
                particlecolumns={this.articlecolumns}
                tableHeading={this.state.tableHeaderData}
                defaultSorted={defaultSorted}
                branchData={getBranches.getBranchesList}
                name="Branches"
              />
            </div>
          </div>
        </Container>
        <BranchModal
          globals={globals.globals}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
          ParenthandleInputChange={this.handleInputChange}
          ParenthandleFormSubmitInsert={this.InserthandleFormSubmit}
          stateData={this.state}
        />
        <BranchModalEdit
          globals={globals.globals}
          show={this.state.modalShow1}
          onHide={() => this.setState({ modalShow1: false })}
          stateData={this.state}
          ParenthandleInputChange={this.handleInputChange}
          ParenthandleFormSubmit={this.handleFormSubmit}
        />

        {/* Shown instead of creating / editing / deleting when the grant is missing.
            One modal serves every intercepted action. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    );
  }
}
export default withRouter(
  compose(
    // skip: is_view === 0 → don't fetch the module's data at all. Without this the
    // queries would still run and the branch list would sit in the Apollo cache even
    // though the Access Denied card is what gets rendered.
    graphql(
      GET_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          },
          fetchPolicy: 'network-only'
        }),
        skip: () => !canView(BRANCHES_MODULE, BRANCHES_SUB),
        name: "globals"
      }
    ),
    graphql(
      FETCH_BRANCHES,

      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          },
          fetchPolicy: 'network-only'
        }),
        skip: () => !canView(BRANCHES_MODULE, BRANCHES_SUB),
        name: "getBranches"
      }
    ),
    graphql(EDIT_BRANCH, {
      name: "editbranch"
    }),
    graphql(DELETE_BRANCH, {
      name: "handleDelete"
    }),
    graphql(ADD_BRANCH, {
      name: "addbranch"
    })
  )(BranchesSection)
);
